export enum FacilityType {
  ADDICTION_SERVICE_CLINIC = 16,
  ASSISTED_LIVING = 7,
  BEHAVIOURAL_CENTER = 21,
  BIRTH_CENTER = 17,
  BLOOD_BANK = 12,
  DIALYSIS_CENTER = 9,
  GENERAL_HOSPITAL = 1,
  HOME_HEALTH_CARE = 8,
  HOSPICE_CARE = 18,
  LONG_TERM_ACUTE_CARE_CENTER = 19,
  LONG_TERM_CARE_FACILITY = 3,
  MEMORY_CARE_AND_ALZHEIMERS_FACILITIES = 13,
  PLASMA_CENTER = 14,
  PRIMARY_CARE_CLINIC = 2,
  PSYCHIATRIC_HOSPITAL = 10,
  REGIONAL_HOSPITAL = 11,
  REHABILITATION_FACILITY = 4,
  SKILLED_NURSING_FACILITIES = 15,
  SPECIALIZED_CLINIC = 6,
  URGENT_CARE_CLINIC = 5,
  WOUND_CLINIC = 20
}
export const FACILITY_TYPES_LIST = [
  {
    value: FacilityType.ADDICTION_SERVICE_CLINIC,
    label: 'Addiction Service Clinic',
    description:
      'Clinic providing treatment and support for substance abuse and addiction'
  },
  {
    value: FacilityType.ASSISTED_LIVING,
    label: 'Assisted Living',
    description: 'Assisted living facility'
  },
  {
    value: FacilityType.BEHAVIOURAL_CENTER,
    label: 'Behavioural Center',
    description:
      'Facility providing comprehensive behavioral health and mental health services'
  },
  {
    value: FacilityType.BIRTH_CENTER,
    label: 'Birth Center',
    description: 'Facility specializing in natural childbirth and maternal care'
  },
  {
    value: FacilityType.BLOOD_BANK,
    label: 'Blood Bank',
    description:
      'Facility for collection, testing, and storage of blood products'
  },
  {
    value: FacilityType.DIALYSIS_CENTER,
    label: 'Dialysis Center',
    description: 'Dialysis treatment center'
  },
  {
    value: FacilityType.GENERAL_HOSPITAL,
    label: 'General Hospital',
    description: 'General hospital facility'
  },
  {
    value: FacilityType.HOME_HEALTH_CARE,
    label: 'Home Health Care',
    description: 'Home health services'
  },
  {
    value: FacilityType.HOSPICE_CARE,
    label: 'Hospice Care',
    description:
      'Compassionate end-of-life care facility for terminally ill patients'
  },
  {
    value: FacilityType.LONG_TERM_ACUTE_CARE_CENTER,
    label: 'Long Term Acute Care Center',
    description:
      'Specialized facility for patients requiring extended acute medical care'
  },
  {
    value: FacilityType.LONG_TERM_CARE_FACILITY,
    label: 'Long Term Care Facility',
    description: 'Long-term care facility'
  },
  {
    value: FacilityType.MEMORY_CARE_AND_ALZHEIMERS_FACILITIES,
    label: "Memory Care and Alzheimer's Facilities",
    description:
      "Specialized care for patients with memory disorders and Alzheimer's disease"
  },
  {
    value: FacilityType.PLASMA_CENTER,
    label: 'Plasma Center',
    description: 'Facility specializing in plasma collection and donation'
  },
  {
    value: FacilityType.PRIMARY_CARE_CLINIC,
    label: 'Primary Care Clinic',
    description: 'Medical clinic'
  },
  {
    value: FacilityType.PSYCHIATRIC_HOSPITAL,
    label: 'Psychiatric Hospital',
    description: 'Mental health treatment facility'
  },
  {
    value: FacilityType.REGIONAL_HOSPITAL,
    label: 'Regional Hospital',
    description: 'Regional hospital providing comprehensive healthcare services'
  },
  {
    value: FacilityType.REHABILITATION_FACILITY,
    label: 'Rehabilitation Facility',
    description: 'Physical rehabilitation facility'
  },
  {
    value: FacilityType.SKILLED_NURSING_FACILITIES,
    label: 'Skilled Nursing Facilities',
    description:
      'Facilities providing skilled nursing care and rehabilitation services'
  },
  {
    value: FacilityType.SPECIALIZED_CLINIC,
    label: 'Specialized Clinic',
    description: 'Outpatient surgery center'
  },
  {
    value: FacilityType.URGENT_CARE_CLINIC,
    label: 'Urgent Care Clinic',
    description: 'Urgent care center'
  },
  {
    value: FacilityType.WOUND_CLINIC,
    label: 'Wound Clinic',
    description:
      'Specialized clinic for treatment of complex and chronic wounds'
  }
];
